import { useState, useEffect, useCallback } from 'react'

// MUI default sm breakpoint is 600px
const SM_BREAKPOINT = 600

function useMediaQuery(query) {
  const getMatches = useCallback(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches
    }
    return false
  }, [query])

  const [matches, setMatches] = useState(getMatches)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query)
    const handleChange = () => setMatches(mediaQueryList.matches)

    // Set initial value
    handleChange()

    // Modern browsers
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', handleChange)
      return () => mediaQueryList.removeEventListener('change', handleChange)
    }
    // Fallback for older browsers
    mediaQueryList.addListener(handleChange)
    return () => mediaQueryList.removeListener(handleChange)
  }, [query])

  return matches
}

// Custom hook to export isMobile and isLandscape
export const useDeviceQueries = () => {
  const isMobile = useMediaQuery(`(max-width: ${SM_BREAKPOINT}px), (max-height: ${SM_BREAKPOINT}px)`)
  const isLandscape = useMediaQuery('(orientation: landscape)')

  return { isMobile, isLandscape }
}
